/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { CLOUDINARY } from 'middleware/cloudinary';

export const UPLOAD_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILURE = 'UPLOAD_IMAGE_FAILURE';

/**
 * Upload image to cloudinary.
 *
 * @param {Object} data - Picture data object.
 * @param {string} data.key - UUID.
 * @param {blob} data.file - Image file.
 *
 * @return {Object}
 */
export const uploadImage = data => ({
  [CLOUDINARY]: {
    body: data,
    types: [UPLOAD_IMAGE_REQUEST, UPLOAD_IMAGE_SUCCESS, UPLOAD_IMAGE_FAILURE],
  },
});
